// extracted by mini-css-extract-plugin
export default {"ModalContainer":"ResetPasswordModal_ModalContainer__cSLN0"};